// `DEV-95.1` (находка в `DEV-88`; та же природа, что `ТЕСТ-Н36`): одна запись об
// ошибке запроса — на все места.
//
// Прежде каждая ошибка печаталась своим `console.error(…, error)`, и в консоль
// уходил весь объект ошибки: `config.headers` (там `x-csrf-token`), `config.data`
// (там пароль) и `response.data` (там бывает что угодно). Такую запись нельзя ни
// показать, ни сохранить. Здесь из ошибки берётся только то, по чему её находят в
// журнале сервера, и ничего больше:
//
// - метод и маршрут — что за запрос;
// - код ответа — чем он кончился;
// - `X-Request-Id` — номер запроса на сервере (его ставит
//   `back_balance/middlewares/error-middleware.js`): по нему запись браузера
//   сходится с записью сервера;
// - `message` — текст ошибки;
// - время.
//
// Чего в записи нет и не должно появиться: заголовков запроса, тела запроса,
// тела ответа и самого объекта ошибки. Проверка — `logApiError.test.ts`.

export interface IApiErrorRecord {
  method: string;
  url: string;
  status: number | null;
  requestId: string;
  message: string;
  at: string;
}

/** Значение заголовка — у axios это и `Headers`, и обычный объект. */
function headerValue(headers: any, name: string): string | null {
  if (!headers) return null;

  const value =
    typeof headers.get === "function" ? headers.get(name) : headers[name];

  return value === undefined || value === null || value === ""
    ? null
    : String(value);
}

/**
 * Идентификатор запроса — заголовок `X-Request-Id` ответа. Заголовка нет (ответ
 * не от нашего обработчика) — «нет», а не выдуманный номер.
 */
export function requestIdFromResponse(response: any): string {
  return headerValue(response?.headers, "x-request-id") || "нет";
}

/** Что именно попадёт в запись. Ничего сверх названного здесь нет. */
export function describeApiError(error: any): IApiErrorRecord {
  const config = error?.config || {};
  const status = error?.response?.status;

  return {
    method: config.method ? String(config.method).toUpperCase() : "—",
    url: config.url ? String(config.url) : "—",
    status: typeof status === "number" ? status : null,
    requestId: requestIdFromResponse(error?.response),
    message: error?.message ? String(error.message) : String(error ?? ""),
    at: new Date().toISOString(),
  };
}

/** Одна запись об ошибке запроса. */
export function logApiError(label: string, error: unknown): void {
  // eslint-disable-next-line no-console
  console.error(label, describeApiError(error));
}
